module.exports = __webpack_public_path__ + "img/UA house 二维码-s.4708b9a.png";